import Colors from '../../../../themes/Colors';
import styled from 'styled-components'

const BrandsSectionHolder = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    h2 {
      font-family: 'Roboto', sans-serif;
      font-size: 24px;
      font-weight: bold;
      line-height: 32px;
      margin: 0;
      color: ${Colors.textStrong};
    }

    .ant-input-search {
      max-width: 280px;
    }
  }

  .brands-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
  }
`

export default BrandsSectionHolder
